/** @format */

import {
  Box,
  Button,
  Card,
  CardContent,
  Checkbox,
  DialogActions,
  DialogContentText,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  List,
  ListItem,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Select,
  Stack,
  Typography,
  Radio,
  RadioGroup,
  Modal
} from "@mui/material";
import { useOutletContext,useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import styled, { keyframes } from "styled-components";
import SelectedVariableDetails from "../Pdf-Utils/SelectedVariableDetails";
import { pdfToolApi } from "../../../services/PdfEditor/pdfToolApi";
// import { toast } from "react-toastify";
import { Icon } from "@iconify/react";
import PdfPreviewDrawer from "../Modal/PdfPreviewDrawer";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import {
  dynamicEsignData,
  filterDigitalStampAndMultiSignerData,
  kycDefaultSelectData,
  modifyAddedPdfData,
  modifyAddedPdfDataSequence,
  scrollToId,
  transformDataInObj,
  transformedOtherAction,
  transformSelectData,
} from "../../../Helpers";
import { apiEndpoint } from "../../../urls";
import axiosInstance from "../../../services/axiosInstance";
import AddedOrRemoveCor from "./AddedOrRemoveCor";
import ConfirmationModal from "./ConfirmationModal";
import VariableNotExist from "./VariableNotExist";
import NegativeCoordinates from "./NegativeCoordinates";
import { removedCoordinateFunc } from "../../../store/reducers/pdfeditor/pdfAddedRemovedCoordSlice";
import AddSignerModule from "../Pdf-Utils/AddEsigner";
import { selectOptions } from "../../../store/reducers/pdfeditor/selectOptionsSlice"; 
import { addSigner } from "../../../store/reducers/pdfeditor/addSignerSlice";
import { useToast } from "@chakra-ui/react";
import { TextField } from "@mui/material";
// import { genrateEsignTokenWithDocumentID } from "../../../store/genrateEsignTokenWithDocumentIDSlice";
import { updateSelectedDocument } from "../../../store/reducers/pdfeditor/pdfDetailsSlice";
import { updateAllCoordinates } from "../../../store/reducers/pdfeditor/pdfCoordinatesSlice";
import { clearAllToolModificationData } from "../../../store/reducers/pdfeditor/toolsModificationSlice";
import { updatePageData } from "../../../store/reducers/pdfeditor/pageModificationSlice";
import { clearInsertPdf } from "../../../store/reducers/pdfeditor/insertPdfSlice";
import { resetDeletedImages } from "../../../store/reducers/pdfeditor/deletedImageSlice";
import { getDocumentsDetailsApi } from "../../../store/reducers/pdfeditor/getDocumentsDetailSlice";
import { setUploadedDocument, toggleFullView } from "../../../store/reducers/uploadDocumentSlice";
import { clearUploadedDocument } from "../../../store/reducers/uploadDocumentSlice";

const PdfControls = ({ containerRef, pdfPagesRef, pdfPages, handleReviewAndSend, areDigitalSignersOnTop, setSignerSequenceMismatch }) => {
  const [loader, setLoader] = useState(false);
  const { setOpenSideBar, openSideBar } = useOutletContext();
  const [loadingVariableExist, setLoadingVariableExist] = useState(false);
  const { pdfEditortoken } = useSelector((state) => state.pdfEditortoken);
  console.log("pdfEditortoken or openSideBar", pdfEditortoken,openSideBar)
  const [open, setOpen] = useState(false);
  const [preview2, setPreview2] = useState(false);
  const [saveDraft, setSaveDraft] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { modifiedCoordinates, modifiedCoordinatesRedo } = useSelector(
    (state) => state.pdfAddremoved || []
  );  
  const { documentData } = useSelector(
      (state) => state.genrateEsignTokenWithDocumentID ||[]
    );
 
  const { signers } = useSelector((state) => state.signers);
  const toast = useToast();
  const showToast = (message, status) => {
    toast({ title: message, status, duration: 3000, isClosable: true, position: "top-right" });
  };
  useEffect(() => {
    console.log(  
      "data in slice of add remove coord",
      modifiedCoordinates,
      modifiedCoordinatesRedo
    );
  }, [modifiedCoordinates]);
  const { deletedImages } = useSelector((state) => state.deletedImage || []);
  console.log("deleteimages data is", deletedImages);

  const { coordinates } = useSelector((state) => state.pdfCoordinates || []);
  const { insertPdfData } = useSelector((state) => state.insertPdf || []);
  let type = sessionStorage.getItem("type");
  const { deletedPageData, addedPageData } = useSelector(
    (state) => state.pageModification || []
  );
  const [templateData, setTemplateData] = useState(null);
  const { uploadedDocument} = useSelector((state) => state.uploadDocument);
  const [pageHeight, setPageHeight] = useState([]);
  const [pdfUrlKyc, setPdfUrlKyc] = useState(null);

  const [afterTestResult, setAfterTestResult] = useState([]);
  const [addedCoord, setAddedCoord] = useState(0);
  const [removedCoord, setRemovedCoord] = useState(0);
  const [missingVariablesState, setMissingVariablesState] = useState([]);
  const [negativeCoordinates, setNegativeCoordinates] = useState([]);

  const [openTestModal, setOpenTestModal] = React.useState(false);

  const [openAddedOrRemovedCor, setOpenAddedOrRemovedCor] = useState(false);

  const [openVariableNotExist, setOpenVariableNotExist] = useState(false);

  const [openConfirmationModal, setOpenConfirmationModal] = useState(false);
  const [issaveDraftExit, setIssaveDraftExit] = useState(false);

  const [negativeDimensionModal, setNegativeDimensionModal] = useState(false);
  const [signerStampModal, setSignerStampModal] = useState({
    open: false,
    signer: null,
  });

  const [handleValidationStatus,setHandleValidationStatus]=useState(false)
  const [askPasswordForEsign,setAskPasswordForEsign]=useState(null)
  const [password,setPassword]=useState("")
  const [fieldValues,setFieldValues]=useState(null)
const [payload, setPayload] = useState("");   

  const [isChecked, setIsChecked] = useState(true);
  const [matchedPercentage, setMatchedPercentage] = useState(70);
  useEffect(() => {
    if(payload)
    {
      sendPayload(payload)
    }    
  }, [payload]);

  const sendPayload = async (payload) => {
    if (!payload) return; 
  
    const apiUrl = `${apiEndpoint.esignBaseUri}/MultieSign/RequestMutiSign`;
  
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          signature: payload.api_header.signature,
        },
        body: JSON.stringify(payload.api_payload),
      });
  
      const result = await response.json();
      console.log("multisign Data:", result);
  
      if (result.success) {
        showToast(result?.message, "success");
      } else {
        showToast(result?.message || "Something went wrong", "error");
      }
      setPassword("");
      setLoader(false);
      dispatch(updateSelectedDocument(null));
      dispatch(updateAllCoordinates(null));
      dispatch(clearAllToolModificationData());
      dispatch(updatePageData([]));
      dispatch(clearInsertPdf({}));
      dispatch(resetDeletedImages([]))
      dispatch(addSigner(null));
      dispatch(getDocumentsDetailsApi(pdfEditortoken?.access));
    } catch (error) {
      console.error("Error fetching data:", error);
      showToast("Failed to send data", "error");
    }
  };

  const handleCloseSignerStampModal = () => {
    setSignerStampModal({ open: false, signer: null });
  };

  const handleOpenNegativeDimensionModal = () => {
    setNegativeDimensionModal(true);
  };
  const handleCloseNegativeDimensionModal = () => {
    setNegativeDimensionModal(false);
  };

  const handleOpenVariableNotExist = () => {
    setOpenVariableNotExist(true);
  };
  const handleCloseVariableNotExist = () => {
    setOpenVariableNotExist(false);
  };

  useEffect(() => {
    if (!Array.isArray(signers) || signers.length === 0) {
        console.log('signers is empty or not an array');
        return;
    }

    console.log('signers pdfControl', signers);

    let signerData = {};
    signers.forEach((item, index) => {
        signerData["signer-" + (index+1)] = {...item,mobile:item.phone,esign_type: "EKYC",
          dynamic_coordinate: {}};
    });

    setFieldValues(signerData);

  }, [signers]);
  console.log("fieldValues",fieldValues)

  const checkBlankFields = (signers) => {
    return signers.some(item => {
        return Object.values(item).some(value => value === "" || value === null || value === undefined);
    });
};
  const handleOpenConfirmationModal = () => {
    setOpenConfirmationModal(true);
    let signerList=[]
  //  signers.forEach(signer => {
  //     const signerLabel = `signer-${signer.sequence}`;
  //     const match = coordinates.find(option => option.value === signerLabel);
  //     if (!match) {
  //       signerList.push(`Signer ${signer.sequence} stamp does not exist!`);
  //     }
  //   });

  //   if (signerList?.length > 0) { 
  //     setSignerStampModal({ open: true, signer: signerList });
  //   } else {
  //     setOpenConfirmationModal(true);
  //   }
  };

  const isReviewDisabled = () => {
    if (!signers || signers.length === 0) return true;
  
    let disabled = false;
  
    signers.forEach((signer) => {
      const signerLabel = `signer-${signer.sequence}`;
      const match = coordinates.find(coord => coord.value === signerLabel);
      console.log(match)
      if (!match) {
        disabled = true;
      }
    });  
    return disabled;
  };

  const handleCloseConfirmationModal = async (IsSaveDraft) => {
    setOpenConfirmationModal(false);
    if(IsSaveDraft)
    {
      handleSaveCoordinate("", IsSaveDraft);
      setIssaveDraftExit(true);
    }
  };

  const handleClickOpenTestModal = () => {
    setOpenTestModal(true);
  };

  const handleCloseTestModal = () => {
    setOpenTestModal(false);
  };

  const handleOpenAddedOrRemovedModal = () => {
    setOpenAddedOrRemovedCor(true);
  };

  const handleCloseAddedOrRemovedCor = () => {
    setOpenAddedOrRemovedCor(false);
  };

  const [selectedMultiSign, setSelectedMultiSign] = useState("");
  const [multiSigners, setMultiSigners] = useState([]);
  const [openMultiSignerModal, setOpenMultiSignerModal] = React.useState(false);
  const handleClickOpenMultiSignerModal = () => {
    setOpenMultiSignerModal(true);
  };

  const handleCloseMultiSignerModal = () => {
    setOpenMultiSignerModal(false);
  };

  useEffect(() => {
    if (!pdfPages) return;
    const heights = pdfPages.map((canvas) => canvas.canvas.height / 1.5);
    setPageHeight(heights);
  }, [pdfPages]);

  const handleDeleteImages = () => {
    if (deletedImages?.length > 0) {
        pdfToolApi
          .deleteImage(deletedImages, pdfEditortoken?.access)
          .then((res) => {
            if (res.status) {
              showToast("mages deleted successfully", "success");
            } else {
              showToast(res.message, "error");
            }
          })
          .catch((error) => {
            console.log(error);
          });
    }
  };

  // console.log("missing variables are: ", missingVariablesState)

  const checkCoordinates = async (pagesData) => {
    // Loop through the outer keys (representing page numbers)
    for (const pageNumber in pagesData) {
      const pageCoordinates = pagesData[pageNumber];

      // Loop through each coordinate name and data within the page
      for (const [coordinateName, coordinateArray] of Object.entries(
        pageCoordinates
      )) {
        console.log(coordinateName);
        if (
          coordinateName === "single_page" ||
          coordinateName === "multiple_pages"
        ) {
          continue;
        }
        // console.log("coordinate naemalefafnaeif", coordinateName);
        // Check if coordinateArray is an actual array
        for (const coord in coordinateArray) {
          // console.log("yeb adsfiuh", coordinateArray[coord]);
          if (Array.isArray(coordinateArray[coord])) {
            // console.log("coorsaoifearha", coord);

            // Iterate through the array of coordinate objects
            for (const coordinate of coordinateArray[coord]) {
              const { height, width } = coordinate;
              console.log("Height...........:", height, "Width:", width);

              // Check if height or width is negative
              if (height < 0 || width < 0) {
                showToast(`The coordinate "${coord}" on page ${coordinateName} has a negative height or width.`, "warning");
                return true;
              }
            }
          } else {
            console.error(`Expected array but found ${typeof coordinateArray}`);
          }
        }
      }
    }
  };
  // Inside your component

  const checkNegativeCoordinates = async (pagesData) => {
    let negativeCoords = [];
    console.log("checkNegativeCoordinates func called", pagesData);
    // Loop through the outer keys (representing page numbers)
    for (const pageNumber in pagesData) {
      const pageCoordinates = pagesData[pageNumber];

      // Loop through each coordinate name and data within the page
      for (const [coordinateName, coordinateArray] of Object.entries(
        pageCoordinates
      )) {
        console.log(coordinateName);

        if (
          coordinateName === "single_page" ||
          coordinateName === "multiple_pages"
        ) {
          continue;
        }

        // Iterate through the array of coordinate objects
        for (const coord in coordinateArray) {
          if (Array.isArray(coordinateArray[coord])) {
            for (const coordinate of coordinateArray[coord]) {
              const { height, width } = coordinate;
              console.log("Height...........:", height, "Width:", width);

              // Check if height or width is negative
              if (height < 0 || width < 0) {
                // Store the coordinates with negative height or width
                negativeCoords.push(
                  negativeCoords.push({
                    pageNumber: coordinateName,
                    value: coord,
                    coordinateName: coordinateName,
                    coord: coord,
                    height: height,
                    width: width,
                  })
                );
              }
            }
          } else {
            console.error(`Expected array but found ${typeof coordinateArray}`);
          }
        }
      }
    }

    // If any negative coordinates are found, store them in state
    if (negativeCoords.length > 0) {
      console.log("Negative coordinates found:", negativeCoords);
      setNegativeCoordinates(negativeCoords);

      // Return true if any negative coordinates are found
      return true;
    }

    // If no negative coordinates are found, return false
    return false;
  };

  const checkVariableExistence = async (pagesData) => {
    setMissingVariablesState([]);
    const fetchData = async () => {
      setLoadingVariableExist(true);
      try {
        let data;
        const type = sessionStorage.getItem("type");
        console.log("type in fetchdata is", type);
        return data;
      } catch (error) {
        console.error("Error fetching default data:", error);
        return null; // Return null or handle error case
      } finally {
        setLoadingVariableExist(false);
      }
    };

    const d = await fetchData();
    // console.log("data from fetchData", d);
    if (d?.length > 0) {
      // List of variables to be excluded from the comparison
      const excludeVariables = [
        "digital_stamp",
        "watermark_image",
        "multi_signers",
        "permanent_checkbox",
        "imageVal",
        "imageField",
        "textField",
        "eraseField",
        "eraserField",
      ];

      // Array to hold missing variables
      let missingVariables = [];

      // Assuming `coordinates` is available here
      for (let coordinate of coordinates || []) {
        const coordinateValue = coordinate.value;
        console.log("coordinate value is", coordinateValue);

        // Skip the comparison if the coordinateValue is in the exclude list
        if (excludeVariables.includes(coordinateValue)) {
          continue;
        }

        // Check if `coordinateValue` is found in the `d` array based on `variableName`

        const found = d.some((item) => {
          console.log(
            "item and value is ",
            item.value?.variableName?.toLowerCase(),
            coordinateValue?.toLowerCase()
          );
          return coordinateValue
            ?.toLowerCase()
            ?.includes(item.value?.variableName?.toLowerCase());
        });
        // const found = d.some(item => {console.log('item and value is ', item.value?.variableName?.toLowerCase(), coordinateValue?.toLowerCase() );return item.value?.variableName?.toLowerCase()?.includes(coordinateValue?.toLowerCase()) });

        if (!found) {
          // Push the full coordinate object to the missingVariables array
          missingVariables.push(coordinate);
        }
      }

      // If any missing variables exist, handle them after the loop
      if (missingVariables.length > 0) {
        console.log("Missing variables:", missingVariables);

        // Update the state with missing variables
        setMissingVariablesState(missingVariables);

        // You can show a toast for each missing variable or a combined message
        // missingVariables.forEach(variable => {
        //   toast.warning(`"${variable.value}" Variable Doesn't Exist.`);
        // });

        // Return true if there are missing variables
        return true;
      }

      // If no missing variables, return false (comparison passed)
      return false;
    } else {
      return false;
    }
  };

  useEffect(() => {
    const saveFunc = async () => {
      if (templateData) {
        setLoader(true);
        let documentId = uploadedDocument?.data?.document_id;

        // Remove excess keys from document_template
        const documentTemplate = templateData?.templateData?.document_template;
        const pdfPageLimit = pdfPages?.length;
        // console.log("pdf pages length in useeffect is: ", pdfPages?.length);

        if (documentTemplate && pdfPageLimit) {
          // Iterate over each page in the documentTemplate
          Object.keys(documentTemplate).forEach((pageNumber) => {
            // Convert the pageNumber key to a number
            const pageNum = Number(pageNumber);

            // Check if the page number exceeds the pdfPageLimit
            if (pageNum > pdfPageLimit) {
              // Remove the entire page if it exceeds the page limit
              delete documentTemplate[pageNumber];
            }
          });
        }

        console.log(
          "pdf pages length in useeffect is: doc template",
          documentTemplate
        );

        // 1. Handle 'single_page' removal
        const singlePageTemp =
          templateData?.templateData?.other_actions?.single_page;
        if (singlePageTemp && pdfPageLimit) {
          // console.log("templateData is....... inside singlePageTemp");
          const keys = Object.keys(singlePageTemp);
          // Convert keys to numbers before comparing them with pdfPageLimit
          keys.forEach((key) => {
            if (Number(key) > pdfPageLimit) {
              delete singlePageTemp[key];
            }
          });
        }

        // 2. Handle 'multiple_pages' removal based on 'start_at'
        const multiPageTemp =
          templateData?.templateData?.other_actions?.multiple_pages;
        if (multiPageTemp && pdfPageLimit) {
          // console.log("templateData is....... inside multiPageTemp");
          const insertDoc = multiPageTemp?.insert;
          if (insertDoc) {
            Object.keys(insertDoc).forEach((key) => {
              if (insertDoc[key]?.start_at > pdfPageLimit) {
                delete insertDoc[key]; // Remove keys where 'start_at' exceeds pdfPageLimit
              }
            });
          }
        }

        let resp = await checkCoordinates(templateData?.templateData);
        // let resp2 = await  checkVariableExistence(templateData?.templateData);
        if (resp) {
          setLoader(false);
          return;
        } else {
          pdfToolApi.refreshToken(pdfEditortoken?.refresh).then((res) => {
            pdfToolApi.setTemplate(templateData?.templateData, documentId, res.access).then((res) => {
              if (templateData.preview === "") {
                setLoader(false);
              }
              if (res.status) {
                showToast("Template applied successfully.", "success");
                handleDeleteImages();
                handleCloseConfirmationModal();
                setSaveDraft(true)
                const newdocumentData = { data: res.data, fullView: true };
                localStorage.setItem("uploadedDocument", JSON.stringify(newdocumentData));
                dispatch(setUploadedDocument(JSON.parse(localStorage.getItem("uploadedDocument"))));
                if (templateData.preview === "preview") {
                  console.log(
                    "templateData preview is:",
                    templateData?.preview
                  );

                  setOpen(true);
                  if (preview2) {
                    callTestingAPI();
                  }
                  setTemplateData(null);
                }
                dispatch(toggleFullView()); 
                setOpenSideBar(!openSideBar);
                if(issaveDraftExit)
                {
                  dispatch(updateSelectedDocument(null));
                  dispatch(updateAllCoordinates(null));
                  dispatch(clearAllToolModificationData());
                  dispatch(updatePageData([]));
                  dispatch(clearInsertPdf({}));
                  dispatch(resetDeletedImages([]))
                  dispatch(addSigner(null));
                  dispatch(getDocumentsDetailsApi(pdfEditortoken?.access));
                  dispatch(clearUploadedDocument());
                  window.location.replace(`${process.env.PUBLIC_URL}/esign/documents?activeTab=1`);
                }
              } else {
                showToast(res.message, "error");
              }
            })
            .catch((error) => {
              setLoader(false);
              showToast(error.message, "error");
            });
          });
        }
      }
    };
    saveFunc();
  }, [templateData]);

  function findMultiSigners(documentTemplate) {
    const signersSet = new Set();

    for (const page in documentTemplate) {
      if (documentTemplate[page].hasOwnProperty("multi_signers.signer_1")) {
        signersSet.add("multi_signers.signer_1");
      }
      if (documentTemplate[page].hasOwnProperty("multi_signers.signer_2")) {
        signersSet.add("multi_signers.signer_2");
      }
      if (documentTemplate[page].hasOwnProperty("multi_signers.signer_3")) {
        signersSet.add("multi_signers.signer_3");
      }
    }

    return Array.from(signersSet);
  }

  const handleTestCoordinates = async () => {
    const item = coordinates.find((item) => item.value === "" || !item.value);
    if (item) {
      scrollToId(`page-${item.pageNumber}`, pdfPages, containerRef);
      showToast(`You missed selecting a variable on page number ${item.pageNumber}.`, "warning");
      return;
    }
    let transformedData = await transformDataInObj(coordinates);

    let addedPdf = modifyAddedPdfData(insertPdfData);
    let otherActionData = transformedOtherAction(
      deletedPageData,
      addedPageData
    );
    let templateData = {
      document_template: transformedData,
      other_actions: {
        single_page: otherActionData,
        multiple_pages: { insert: addedPdf },
      },
    };
    const findMultiSign = findMultiSigners(templateData.document_template);
    console.log("findMultiSign", findMultiSign);
    if (findMultiSign?.length > 0 && !selectedMultiSign) {
      setMultiSigners(findMultiSign);
      handleClickOpenMultiSignerModal();
    } else {
      const companyName = sessionStorage.getItem("companyName");
      let splitSelectedMultiSign = selectedMultiSign?.split(".")?.["1"];
      setLoader(true);
      try {
        const response = await axiosInstance.post(`/test_cloudesign/${uploadedDocument?.data?.document_id}/${uploadedDocument?.workflow_key}/${companyName}`,
          { selectedSigner: splitSelectedMultiSign }
        );
        console.log("test coordinate response data is:", response.data);
        if (response?.status === false) {
          setAfterTestResult(response?.data?.msg);
        }
        setLoader(false);
        // setAfterTestResult(response?.data?.data);
        handleCloseMultiSignerModal();
        handleClickOpenTestModal();
        // console.log('multising found are', findMultiSign)
        // console.log('multising found are', selectedMultiSign)
        setSelectedMultiSign("");
        setMultiSigners([]);
      } catch (error) {
        setLoader(false);
        console.error("There was an error making the request:", error);
        showToast(`There was an error making the request: ${error}`, "error");
        setSelectedMultiSign("");
        setMultiSigners([]);
        handleCloseMultiSignerModal();
      }
    }
  };

  const handleSaveCoordinate = async (preview, IsSaveDraft) => {
    const isOrderValid = areDigitalSignersOnTop(signers);
    if(!isOrderValid && !IsSaveDraft)
    {
      setSignerSequenceMismatch(true);
      console.log("Are digital signers on top?", isOrderValid);
      return;
    }
    const item = coordinates.find((item) => item.value === "" || !item.value);
    if (item) {
      scrollToId(`page-${item.pageNumber}`, pdfPages, containerRef);
      showToast(`You missed selecting a variable on page number ${item.pageNumber}.`, "warning");
      return;
    }
   
    const imageItem = coordinates.find(
      (item) => item.value === "imageVal" && item.imageUrl === ""
    );
    console.log("item",item)
    console.log("imageItem",imageItem)
    // console.log("image item for warning", imageItem);
    if (imageItem) {
      scrollToId(`page-${imageItem.pageNumber}`, pdfPages, containerRef);
      showToast(`You missed selecting a variable on page number ${item.pageNumber}.`, "warning");
      return;
    }
    // console.log("before transformed data is", coordinates);
    let transformedData = await transformDataInObj(coordinates);
    // console.log("before transformed data is transformed", transformedData);
    let digitalStampData = await filterDigitalStampAndMultiSignerData(
      transformedData
    );
    let addedPdf = modifyAddedPdfData(insertPdfData);
    let addedPdfSequence = modifyAddedPdfDataSequence(insertPdfData);
    let otherActionData = transformedOtherAction(
      deletedPageData,
      addedPageData
    );
    let templateData = {
      document_template: transformedData,
      other_actions: {
        single_page: otherActionData,
        multiple_pages: { insert: addedPdf },
        multiple_page_sequence: { insert: addedPdfSequence },
      },
    };
    // console.log("template data is...", templateData);
    setTemplateData({ templateData, preview });
    if(!IsSaveDraft)
    {
      handleReviewAndSend();
    }
  };

  const handleSaveCoordinate2 = async (preview) => {
    // console.log("handle save coordinate 2 function called");
    const item = coordinates.find((item) => item.value === "" || !item.value);
    if (item) {
      scrollToId(`page-${item.pageNumber}`, pdfPages, containerRef);
      showToast(`You missed selecting a variable on page number ${item.pageNumber}.`, "warning");
      return;
    }
    const imageItem = coordinates.find(
      (item) => item.data_type === "image_type" && item.imageUrl === ""
    );
    // console.log("image item for warning", imageItem);
    if (imageItem) {
      scrollToId(`page-${imageItem.pageNumber}`, pdfPages, containerRef);
      showToast(`You missed uploading the image on page number ${item.pageNumber}.`, "warning");
      return;
    }

    let transformedData = await transformDataInObj(coordinates);
    let digitalStampData = await filterDigitalStampAndMultiSignerData(
      transformedData
    );
    let addedPdf = modifyAddedPdfData(insertPdfData);
    let addedPdfSequence = modifyAddedPdfDataSequence(insertPdfData);
    let otherActionData = transformedOtherAction(
      deletedPageData,
      addedPageData
    );
    let templateData = {
      document_template: transformedData,
      other_actions: {
        single_page: otherActionData,
        multiple_pages: { insert: addedPdf },
        multiple_page_sequence: { insert: addedPdfSequence },
      },
    };
    console.log("template data is...", templateData);
    await setTemplateData({ templateData, preview });

    let test = callTestingAPI();
    // calling generate sample pdf data api when preview pdf button is clicked.
  };
 

  const orginalCoordinates = uploadedDocument?.data?.document_template;

  function extractCoordinatesFromObject(dataObj) {
    let coordinates = [];
    if (dataObj) {
      for (const [page, fields] of Object.entries(dataObj)) {
        // Extract coordinates from each field type (textField, imageField, etc.)
        for (const [fieldType, fieldArray] of Object.entries(fields)) {
          for (const field of fieldArray) {
            coordinates.push({
              ...field,
              pageNumber: page, // Include page number for easier tracking
              fieldType: fieldType, // Store field type as well
            });
          }
        }
      }
    }
    // Iterate over each page in the object

    return coordinates;
  }

  // Helper function to compare coordinates based on id
  function compareCoordinates(originalCoordinates, newCoordinates) {
    const originalIds = new Set(originalCoordinates?.map((item) => item?.id));
    const newIds = new Set(newCoordinates?.map((item) => item.id));

    // Find added coordinates (present in new array but not in original)
    const addedCoordinates = newCoordinates?.filter(
      (item) => !originalIds.has(item.id)
    );

    // Find removed coordinates (present in original object but not in new array)
    const removedCoordinates = originalCoordinates?.filter(
      (item) => !newIds.has(item.id)
    );

    return {
      addedCoordinates,
      removedCoordinates,
    };
  }

  // Step 1: Extract all original coordinates from the nested object
  const originalCoordinatesfunc =
    extractCoordinatesFromObject(orginalCoordinates);

  // Step 2: Compare the original and new coordinates
  const { addedCoordinates, removedCoordinates } = compareCoordinates(
    originalCoordinatesfunc,
    coordinates
  );
  console.log(
    "added and removed coordinates are: ",
    addedCoordinates,
    removedCoordinates
  );


  let callTestingAPI = async () => {
    try {
      // Refresh the token and wait for the result
      const res = pdfEditortoken

      if (res.access) {
        // Set the loader to true before starting the API call
        setLoader(true);


        try {
          // Call the API to generate the PDF
          const response = await pdfToolApi?.testGeneratePdf(
            uploadedDocument?.workflowName,
            uploadedDocument?.data?.document_id,
            res.access
          );

          console.log("Result from testGeneratePdf:", response);

          // Handle the PDF URL and loader state
          if (response?.status === false && response?.file) {
            showToast(response?.message, "warning");
          } else if (response?.status === true && response?.file) {
            setPdfUrlKyc(`/${response.file}`);
            setPreview2((prev) => !prev);
          }
          // if (response?.file) {
          // }
        } catch (error) {
          console.error("Error while fetching sample PDF data:", error);
        } finally {
          // Ensure the loader is turned off regardless of success or error
          setLoader(false);
          // Optionally toggle preview2 if required (depending on your use case)
          // setPreview2(prev => !prev);
        }
      }
    } catch (error) {
      console.error("Error while refreshing token:", error);
      // Optionally handle token refresh errors
    }
  };

  return (
    <>
      <Button variant="contained" sx={{ width: '126px', height: 46, color: "#185CB7", background: "transparent", textTransform: "none", fontSize: "16px", borderRadius: "10px", border: "1px solid #185CB7", boxShadow: "none", fontWeight: "600",}} onClick={() => handleOpenConfirmationModal()} >
          Save Draft
      </Button>
      <Button variant="contained" sx={{ width: '172px', height: 46, color: "#ffffff", background: "#185CB7", textTransform: "none", fontSize: "16px", borderRadius: "10px", border: "1px solid #185CB7", boxShadow: "none", fontWeight: "500", 
        "&:hover": { background: "#185CB7" }, 
        "&.Mui-disabled": {
          background: "#D8D8D8",
          border: "1px solid #D8D8D8",
          color: "#FFFFFF"
        } }} disabled={isReviewDisabled() } onClick={() => handleSaveCoordinate("")} >
            Review & Send
      </Button>

      <Modal
        open={openConfirmationModal}
        // onClose={handleCloseConfirmationModal}
        // open={openTestModal} onClose={handleCloseTestModal}
      >
        <ConfirmationModal
          added={addedCoordinates?.length}
          removed={removedCoordinates?.length}
          handleSaveCoordinate={handleSaveCoordinate}
          handleCloseConfirmationModal={handleCloseConfirmationModal}
          handleOpenAddedOrRemovedModal={handleOpenAddedOrRemovedModal}
          handleOpenVariableNotExist={handleOpenVariableNotExist}
          missingVariablesState={missingVariablesState}
          // handleOpenNegativeDimensionModal={handleOpenNegativeDimensionModal}
          // negativeCoordinates={negativeCoordinates}
          loader={loader}
          checkVariableExistence={checkVariableExistence}
          // checkNegativeCoordinates={checkNegativeCoordinates}
          templateData={templateData}
          loadingVariableExist={loadingVariableExist}
        />
      </Modal>

      {/* Added Or Removed Coordinates to fix modal */}
      <Dialog
        open={openAddedOrRemovedCor}
        onClose={handleCloseAddedOrRemovedCor}
        // open={openTestModal} onClose={handleCloseTestModal}
      >
        <AddedOrRemoveCor
          setAddedCoord={setAddedCoord}
          setRemovedCoord={setRemovedCoord}
          pdfPagesRef={pdfPagesRef}
          pdfPages={pdfPages}
          containerRef={containerRef}
        />
      </Dialog>

      <Dialog
        open={openVariableNotExist}
        onClose={handleCloseVariableNotExist}
        sx={{ minWidth: "400px", minHeight: "200px" }}
        // open={openTestModal} onClose={handleCloseTestModal}
      >
        <VariableNotExist
          missingVariablesState={missingVariablesState}
          handleCloseVariableNotExist={handleCloseVariableNotExist}
          pdfPagesRef={pdfPagesRef}
          pdfPages={pdfPages}
          containerRef={containerRef}
        />
      </Dialog>

      <Dialog
        open={negativeDimensionModal}
        onClose={handleCloseNegativeDimensionModal}
        sx={{ minWidth: "400px", minHeight: "200px" }}
        // open={openTestModal} onClose={handleCloseTestModal}
      >
        <NegativeCoordinates
          negativeCoordinates={negativeCoordinates}
          handleCloseNegativeDimensionModal={handleCloseNegativeDimensionModal}
          pdfPagesRef={pdfPagesRef}
          pdfPages={pdfPages}
          containerRef={containerRef}
        />
      </Dialog>

      <Dialog open={openTestModal} onClose={handleCloseTestModal}>
        <DialogTitle>Coordinates to Fix</DialogTitle>
        <hr style={{ width: "100%", margin: 0 }} />
        <DialogContent
          sx={{
            width: "400px",
            height: "300px",
            background: "white",
            overflow: "auto",
          }}
        >
          {afterTestResult?.length > 0 ? (
            afterTestResult?.map((item) => {
              return <Typography>{item}</Typography>;
            })
          ) : (
            <Typography>No coordinates to fix</Typography>
          )}
        </DialogContent>
      </Dialog>

      {/* Multi SIgner Modal */}
      <Dialog
        open={openMultiSignerModal}
        onClose={handleCloseMultiSignerModal}
      >
        <DialogTitle>Select Multisigner</DialogTitle>
        <hr style={{ width: "100%", margin: 0 }} />
        <DialogContent
          sx={{
            position: "relative",
            width: "400px",
            height: "200px",
            background: "white",
            overflow: "auto",
          }}
        >
          <InputLabel id='demo-simple-select-label'>
            Select Multisigner
          </InputLabel>
          <Select
            labelId='demo-simple-select-label'
            id='demo-simple-select'
            value={selectedMultiSign}
            label='Select MultiSigner'
            onChange={(e) => setSelectedMultiSign(e.target.value)}
            sx={{ width: "100%" }}
          >
            {multiSigners?.map((item) => {
              return <MenuItem value={item}>{item}</MenuItem>;
            })}
          </Select>
          <Button
            variant='contained'
            sx={{ position: "absolute", bottom: 15, right: 15 }}
            onClick={() => handleTestCoordinates()}
            startIcon={
              loader ? (
                <Icon icon='eos-icons:loading' />
              ) : (
                // <Icon icon="fluent-mdl2:save-template" />
                <Icon icon='grommet-icons:test' />
              )
            }
            disabled={loader}
          >
            Test
          </Button>
        </DialogContent>
      </Dialog>

      
      <Dialog
      open={signerStampModal?.open}
      onClose={handleCloseSignerStampModal}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      maxWidth="md" 
    >
      <DialogTitle id="alert-dialog-title">Signer Stamp Details</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {signerStampModal?.signer?.length > 0 ? (
            <List> 
              {signerStampModal.signer.map((item, index) => (
                      
                <ListItem>
                  <ListItemText 
                    secondary={
                      <Typography
                        variant="body2"
                        style={{ fontFamily: 'cursive' }}
                      >
                        {item}
                      </Typography>
                    }
                  />
                </ListItem> 
                    
              ))}
              </List>
          ) : (
            <Typography variant="body1" align="center">
              No signer stamps available
            </Typography>
          )}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCloseSignerStampModal} color="primary" autoFocus>
          Close
        </Button>
      </DialogActions>
    </Dialog>
    </>
  );
};

export default PdfControls;

const Wrapper = styled.div`
`;
